import { createIcon } from "@chakra-ui/icons";

// Created from code.svg

export const CodeIcon = createIcon({
  displayName: "Code",
  viewBox: "0 0 19 17",
  path: (
    <g>
      <path
        d="M4.53552 11.6673L0.999986 8.13173L4.53552 4.59619M13.7279 4.59619L17.2634 8.13173L13.7279 11.6673"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="10.662"
        y1="2.91856"
        x2="7.68563"
        y2="14.0267"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
  ),
});
